module.exports = __webpack_public_path__ + "img/pic-01.db3f4ef3.png";